import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    loadingInProcess:{
      created_orders: false,
      orders_statuses_statistics: false,
      workers_repairtimes: false,
      revenue: false,
      order_analytics_by_months: false,
      order_analytics_by_posts: false,
      order_analytics: false,
    },
    orders_statuses_statistics: [],
    workers_repairtimes: [],
    posts_repairtimes: [],
    revenue: [],
    order_analytics: [],//по сотрудникам
    order_analytics_by_months: [],
    order_analytics_by_posts: []//по постам
  },
  getters: {
    getField, //vuex-map-fields

  },
  mutations: {
    updateField, //vuex-map-fields

  },
  actions: {
    async get({commit, state, dispatch}, payload) {
      updateField(state, {path: `loadingInProcess.${payload.type}`, value: true});
      return await axios.get(`${this._vm.$apiURL}/analytics/${payload.type}`, {
          params: {
              start_date: payload.start_date,
              end_date: payload.end_date
          }
        })
        .then((response) => {
          updateField(state, {path: `loadingInProcess.${payload.type}`, value: false});
          updateField(state, {path: payload.type, value: response.data.data});
        })
        .catch((error) => {
          updateField(state, {path: `loadingInProcess.${payload.type}`, value: false});
          dispatch('common/showError', {'error': error}, {root: true});
        })
    },
  }
}
